export const PEPPOL_XML_CONTENT_TYPE = 'application/xml';

export const PEPPOL_DETAIL_DIALOG_OPTIONS = {
  width: '90vw',
  maxWidth: '1200px',
  height: '90vh',
} as const;
